
const PerfilUI = () => {
  return (
    <div className=" bg-gray-100">
      
    </div>
  );
};

export default PerfilUI;